import { BaseRequestOptions } from '@angular/http';

export class AngularReduxRequestOptions extends BaseRequestOptions {

    public token: string;

    constructor(angularReduxOptions?: any) {

        super();
        this.token = localStorage.getItem('userToken');
        this.headers.append('Content-Type', 'application/json');
        if (this.token != null && this.token != '')
            this.headers.append('authorization', 'bearer ' + this.token);

        if (angularReduxOptions != null) {

            for (let option in angularReduxOptions) {
                let optionValue = angularReduxOptions[option];
                this[option] = optionValue;
            }
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_common/angular-redux-request-options.ts